import { useCallback, useEffect, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  IconArrowDiagonal,
  IconTwoArrows,
  IconLoader,
  PickerPosition,
  Currency,
  formatBalance,
} from '@ui/src';
// import {
//   Area,
//   AreaChart,
//   CartesianGrid,
//   ResponsiveContainer,
//   XAxis,
//   YAxis,
// } from 'recharts';
import { useAppDispatch, useAppSelector } from '@store';
import {
  // ViewMode,
  DashboardItemProps,
  Period,
} from '../../hoc/dashboard/types';
import { getValueById } from '../../hoc/dashboard/store/slice';
import { useLazyGetFinancialListQuery } from '../../hoc/dashboard/store/services';
import DashboardValuesControls from './dashboard-values-controls';
import getQuery from '../../helpers/get-query';
import { getNameFinancial } from '../../helpers/get-name';

import cn from './dashboard.module.css';

const getValue = (key: string, value: string, baseCurrency?: Currency) => {
  if (key === 'capitalAdequacy') {
    return `${value}%`;
  }
  return `${formatBalance(Number(value), baseCurrency)} ${
    baseCurrency?.name || 'GBP'
  }`;
};

const DashboardFinancial = ({
  // viewMode,
  values,
  // setRightSideVisible,
  setSelectedChart,
  selectedChart,
}: DashboardItemProps) => {
  const [selectedDate, setSelectedDate] = useState<string[]>([]);
  const [period, setPeriod] = useState<Period | undefined>(Period.TODAY);

  const dispatch = useAppDispatch();

  const { baseCurrency } = useAppSelector((state) => state.dashboard);

  const [getFinancial, { isLoading, isFetching }] =
    useLazyGetFinancialListQuery();

  const query = useMemo(
    () => getQuery({ period, date: selectedDate }),
    [period, selectedDate],
  );

  const getFinancialAction = useCallback(() => {
    getFinancial(query);
  }, [query]);

  useEffect(() => {
    getFinancialAction();
  }, [query]);

  let content;

  if (isLoading) {
    content = (
      <div className={cn.dashboardValuesLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <div className={cn.dashboardValuesContent}>
        {isFetching && (
          <div className={cn.dashboardValuesRefetch}>
            <IconLoader />
          </div>
        )}
        {Object.keys(values)?.map((key) => (
          <button
            className={cn.dashboardValue}
            key={key}
            type="button"
            onClick={() => {
              setSelectedChart({
                value: values[key],
                period,
                dates: selectedDate,
              });

              dispatch(
                getValueById({
                  period,
                  dates: selectedDate,
                }),
              );

              // if (viewMode === ViewMode.GRID) {
              //   setRightSideVisible(true);
              // }
            }}
          >
            <div className={cn.dashboardValueNameWrapper}>
              <div className={cn.dashboardValueName}>
                {getNameFinancial(key)}
              </div>
            </div>
            <div className={cn.dashboardValueRight}>
              {/* <div className={cn.dashboardValueRightItem}>{values[key]?.count}</div> */}
              <div className={cn.dashboardValueRightItem}>
                {getValue(key, values[key] as string, baseCurrency as Currency)}
              </div>
              {/* <div
                className={`${cn.dashboardValueRightItem} ${
                  cn.dashboardGraph
                }`}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart height={70} width={189} data={item.data}>
                    <CartesianGrid horizontal={false} vertical={false} />
                    <XAxis
                      dataKey="name"
                      tickLine={false}
                      axisLine={false}
                      tick={false}
                    />
                    <YAxis
                      dataKey="value"
                      tickLine={false}
                      axisLine={false}
                      tick={false}
                    />

                    <defs>
                      <linearGradient
                        id={`gradient-${item.name}`}
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="5%"
                          stopColor="#D1DDE9"
                          stopOpacity={0.6}
                        />
                        <stop
                          offset="100%"
                          stopColor="#D1DDE9"
                          stopOpacity={0.2}
                        />
                      </linearGradient>
                    </defs>
                    <Area
                      dataKey="value"
                      stroke="#9ea7ae"
                      fillOpacity={1}
                      fill={`url(#gradient-${item.name})`}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div> */}
            </div>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      // viewMode === ViewMode.GRID ? cn.dashboardValuesGrid : ''
      className={`${cn.dashboardValues} ${cn.dashboardValuesGrid}`}
    >
      <NavLink to="/reports" className={cn.dashboardValuesTitle}>
        <div className={cn.dashboardValuesTitleIcon}>
          <IconTwoArrows />
        </div>
        <div className={cn.dashboardValuesTitleText}>Financial</div>
        <div className={cn.dashboardValuesTitleArrow}>
          <IconArrowDiagonal />
        </div>
      </NavLink>
      <DashboardValuesControls
        // viewMode={viewMode}
        period={period}
        setPeriod={(nextPeriod) => {
          setPeriod(nextPeriod);
          setSelectedDate([]);

          if (selectedChart) {
            setSelectedChart({ ...selectedChart, period: nextPeriod });
          }
        }}
        setSelectedDate={(dates) => {
          setSelectedDate(dates);

          if (selectedChart) {
            setSelectedChart({ ...selectedChart, dates });
          }
        }}
        selectedDate={selectedDate}
        pickerPosition={PickerPosition.RIGHT}
      />
      {content}
    </div>
  );
};

export default DashboardFinancial;
